import { toRGBA } from '../utils';

const spaceGhost = [255, 255, 255];
const s = (opacity: number = 1) =>
  toRGBA(spaceGhost[0], spaceGhost[1], spaceGhost[2], opacity);

export default s;
